module.exports = __webpack_public_path__ + "public/media/ic_email_ separator.e725c1bd.svg";